import React, { useContext, useEffect, useState } from "react";
import { t } from "i18next";
import Table from "../../../components/Table/Table";
import loaderContext from "../../../context/loader/LoaderContext";
import { loadSupportMembers } from "../../../service/UserService";
import "./SupportMember.css";
import { SupportMember } from "./SupportMember";
import ModalHeader from "../../../components/Modal/ModalHeader";
import ModalFooter from "../../../components/Modal/ModalFooter";
import ModalMain from "../../../components/Modal/ModalMain";
import { Spinner, SpinnerSize } from "@fluentui/react";
import toastContext from "../../../context/toast/ToastContext";
import userContext from "../../../context/users/UserContext";
import { TOAST_TYPE, USERTYPES } from "../../../constants/Constants";
import themeContext from "../../../context/theme/ThemeContext";

const AvailableResource = () => {
  const [dataList, setDataList] = useState([]);
  const { authenticated, loadByUsername, roles } = useContext(userContext); 
  const { showModal, setShowModal, hideAlertModal} = useContext(loaderContext);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } =
  useContext(toastContext);

  useEffect(()=>{
    if (!authenticated) {
      console.log("--- Authentication again ----");
      loadByUsername();
      return;
    }
  },[authenticated]);

  const [loading,setLoading] = useState(true);
  const fetchSupportMembers = async () => {
    try{
      const response = await loadSupportMembers();
      console.log(response);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        if (
          response.data.data.supportMembersData != null ||
          response.data.data.supportMembersData != undefined
        ) {
          setDataList(response.data.data.supportMembersData);
        }
        setLoaderRunning(false);
        setLoading(false);
        ref.current.complete();
      }else{
        setLoaderRunning(false);
        setLoading(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));
      }
    }catch(e){
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));
    }
    
  };

  useEffect(() => {
    setLoaderRunning(true);
    setLoading(true);
    ref.current.continuousStart();
    fetchSupportMembers();
  }, []);

  const handleCancelClick = () => {
    hideAlertModal();
    // setShowModal(()=>{
    //   const newItem = {...showModal};
    //   newItem.show = false;
    //   newItem.type = null;
    //   return newItem;
    // })
  }

  let DefaultButtonList = [
    {
      title: t("button.close"),
      onclick: handleCancelClick,
    },
  ];
 
  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={`${t("available-resources.title")}`}
        handleCancel={() => handleCancelClick()}
      />
    ),
    body: <AvailableMemberBody roles={roles} reasons={dataList} />,
    footer: <ModalFooter PrimaryButtonList={[]} DefaultButtonList={DefaultButtonList} />,
    width: "500px",
  };

  return (
    <>
      {!loading ? <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />:<></>}
    </>
  );
};

export default AvailableResource;

export const AvailableMemberBody = (props) => {
  const roles = props.roles;
  const { getThemeColor } = useContext(themeContext)
  const tableStyle = {
    width: "100%",
    color: getThemeColor("primary-color"),
    fontWeight: "400",
    fontFamily: "Open Sans",
  };

  const headStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
  };

  const bodyRowDataStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
  };

  const reasonBodyStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #878282",
    wordBreak: "break-all",
  };

  const contentStyles = {
    root: {
      backgroundColor: "rgb(22, 21, 20, 0.7)",
    },
  };

  const noReason = {
    padding: "10px",
    textAlign: "center",
  };

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const thheadStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
    borderBottom: "none",
  };

  return (
    <>
      <div className="upload-study-modal-container">
        <div className="container-content">
          {props?.reasons?.length > 0 ? (
            <table style={tableStyle}>
              <thead>
                <tr>
                  <React.Fragment>
                    <th style={thheadStyle}>
                      {t("available-resources.header-name")}
                    </th>
                    <th style={thheadStyle}>
                      {t("available-resources.contact-number")}
                    </th>
                    <th style={thheadStyle}>{t("available-resources.role")}</th>
                    {(roles[0] === USERTYPES.RADIOLOGIST || roles[0] === USERTYPES.ADMIN ) && <th style={thheadStyle}>
                      {t("available-resources.firm-name")}
                    </th>}
                  </React.Fragment>
                </tr>
                <tr style={headStyle}></tr>
                <tr style={headStyle}></tr>
                <tr style={headStyle}></tr>
              </thead>
              <tbody id="unassign-modal_body">
                {props.reasons.map((reason, index) => (
                  <tr key={index}>
                    <>
                      <td style={bodyRowDataStyle}>{reason.name}</td>
                      <td style={bodyRowDataStyle}>{reason.contactNumber}</td>
                      <td style={bodyRowDataStyle}>{reason.category}</td>
                      {(roles[0] === USERTYPES.RADIOLOGIST || roles[0] === USERTYPES.ADMIN ) && <td style={bodyRowDataStyle}>{reason.firmName}</td>}
                    </>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={noReason}>{t("available-resources.no-one-available")}</p>
          )}
        </div>
      </div>
    </>
  );
};
